<div class="h-100 single-report-page">
    <app-admin-report [columns]="zonesReport" [hasFilters]="true" [apiUrl]="zonesReportAPI"
                      reportTitle="ADMINISTRATION.ZONE_PACKAGES_SUMMARY_REPORT_TITLE">
    </app-admin-report>
</div>